export function getRouteForContext (index, params) {
  const programId = params[0]
  const routes = {
    login: {
      remote: `${process.env.MODERAPI}/login`,
    },
    user: {
      remote: `${process.env.MODERAPI}/user?programId=${programId}`,
    },
    'user/locale': {
      remote: `${process.env.MODERAPI}/user/locale`,
    },
    'sub-programs': {
      remote: `${process.env.MODERAPI}/program_data/${programId}/sub_programs`,
    },
    'choice-sheet-notifications': {
      remote: `${process.env.MODERAPI}/choice-sheet-notifications`,
    },
    'program-info': {
      remote: `${process.env.MODERAPI}/programs-info/${params[0]}/${params[1]}`,
    },
    streaming: {
      remote: `${process.env.MODERAPI}/streaming/links/direct?programId=${programId}&flatId=${params[1]}&token=${params[2]}`,
    },
    cart: {
      remote: `${process.env.MODERAPI}/cart/shopping`,
    },
    cache: {
      remote: `${process.env.MODERAPI}/program/cache/${programId}`,
    },
    'program_data/program': {
      remote: `${process.env.MODERAPI}/program_data/${programId}/program`,
    },
    'program_data/sub_programs': {
      remote: `${process.env.MODERAPI}/program_data/${programId}/sub_programs`,
    },
    'program_data/settings': {
      remote: `${process.env.MODERAPI}/program_data/${programId}/settings`,
    },
    'program_data/ambiance': {
      remote: `${process.env.MODERAPI}/program_data/${programId}/ambiance`,
    },
    'program_data/lines': {
      remote: `${process.env.MODERAPI}/program_data/${programId}/lines`,
    },
    'program_data/furniture': {
      remote: `${process.env.MODERAPI}/program_data/${programId}/furniture`,
    },
  }
  return routes[index].remote
}
